import client from './client';

export const paymentCommissionSettingsApi = {
  getActive() {
    return client.get('/payment-commission-settings/active');
  },
  updateActive(data) {
    return client.patch('/payment-commission-settings/active', data);
  },
};

